export default "__VITE_ASSET__b1abf226__"